import React, { useState } from "react";
import PropTypes from "prop-types";
import { Loader } from "../"; // Assurez-vous que le composant Loader est déjà créé et importé
import "./Image.css";
import { Container } from "../../layout";

/**
 * Composant `Image` pour afficher une image avec gestion du chargement.
 *
 * @param {string} src - URL de l'image à afficher.
 * @param {string} alt - Texte alternatif pour l'image. Défaut : "Image".
 * @param {string} loaderColor - Couleur du loader. Défaut : 'var(--c-default)'.
 * @param {string} loaderSize - Taille du loader, valeurs possibles : 'sm', 'md', 'lg'. Défaut : 'md'.
 * @param {string} objectFit - Propriété CSS `object-fit` pour l'image. Défaut : '
 * @param {string} width - Largeur de l'image. Défaut : 'auto'.
 * @param {string} height - Hauteur de l'image. Défaut : 'auto'.
 * @param {number} radius - Rayon de bordure de l'image. Défaut : 0.
 * @param {string} className - Classes CSS additionnelles pour l'image.
 * @param {object} style - Styles CSS additionnels pour l'image.
 * @param {object} styleImage - Styles CSS additionnels pour l'image.
 * @param {object} props - Autres attributs à passer à l'élément `img`.
 * @returns {JSX.Element} Une image avec un effet de chargement.
 */
const Image = ({
  src = "https://musevag.fr/cdn/user/userdefault.png",
  alt = "Image",
  loaderColor = "var(--c-default)",
  loaderSize = "md",
  objectFit = "cover",
  width,
  height,
  radius,
  className,
  style = {},
  styleImage = {},
  children,
  ...props
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  return (
    <Container
      className={`Image ${className}`}
      style={{ width, height, borderRadius: radius, ...style }}
      {...props}
    >
      {!isLoaded && (
        <Container className="Loader">
          <Loader color={loaderColor} size={loaderSize} />
        </Container>
      )}
      <img
        src={src}
        alt={alt}
        className={isLoaded ? "loaded" : ""}
        style={{
          objectFit,
          ...styleImage,
        }}
        onLoad={() => setIsLoaded(true)}
        onError={() => setIsLoaded(true)} // Facultatif : afficher une erreur si l'image échoue à charger
      />
    </Container>
  );
};

Image.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  loaderColor: PropTypes.string,
  loaderSize: PropTypes.oneOf(["sm", "md", "lg"]),
  objectFit: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  radius: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
  styleImage: PropTypes.object,
  props: PropTypes.object,
};

export default Image;
